export default __webpack_public_path__ + "static/media/detail_mobile_13_6.8f426f33.jpg";